interface EpiMenuProps {
  setDisplayValue: (val: number) => void;
  displayValue: number;
  clear: boolean;
  setClear: (val: boolean) => void;
  setIsFiltersOpen?: () => void;
}

const OPTIONS = [
  {label: "Prevalence", value: 0},
  {label: "Incidence", value: 1},
  {label: "Estimated Prevalent Case Count", value: 2},
  {label: "Estimated Incident Case Count", value: 3},
];

const EpiMenu: React.FC<EpiMenuProps> = ({
  setDisplayValue,
  displayValue,
  setClear,
  clear,
  setIsFiltersOpen,
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setDisplayValue(Number(event.target.value));
    setClear(false);
    setIsFiltersOpen?.();
  };

  return (
    <ul>
      {OPTIONS.map((opt) => (
        <li key={opt.value}>
          <label className="label cursor-pointer justify-start ml-5">
            <input
              type="radio"
              className="radio radio-xs bg-white border-accent checked:radio-accent"
              value={opt.value}
              checked={!clear && displayValue === opt.value}
              onChange={handleChange}
            />

            <div className="text-valmidnight text-base ml-2">{opt.label}</div>
          </label>
        </li>
      ))}
    </ul>
  );
};

export default EpiMenu;
